/**
 * Marges des panneaux flottants du site (listes déroulantes, calendriers, infobulles),
 * appliquées par défaut dans components/ui/select.tsx et components/ui/popover.tsx.
 *
 * POURQUOI. Un panneau ouvert en bas d'écran s'ouvre vers le haut. Sans marge, Radix le
 * collait au bord de la fenêtre : il passait SOUS le menu collant du site public (80 px),
 * voire hors de l'écran avec un zoom d'affichage Windows, et ses premières lignes
 * devenaient illisibles (« Comment avez-vous connu… », 22/10/2026). 96 = le menu + une
 * marge. Les listes limitent en plus leur hauteur à la place disponible, et défilent.
 */
export const MARGES_FLOTTANTES = { top: 96, bottom: 16, left: 8, right: 8 };
